import React, {useState} from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import {Col, Row} from "react-bootstrap";
import LeftEvents from "./LeftEvents";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {Link} from "react-router-dom";

export default function Conferences() {
    const Data = [
        // {
        //     venue: 'IIT Tirupati',
        //     title: 'Processing and Fabrication of Advanced Materials',
        //     description: 'September 6 - 8 2023\n' + 'Indian Institute of Technology, Tirupati, India',
        //     img: ['https://files.iittp.ac.in/pdfs/workshop/2023/PFAM%202023%20Logo.JPG'],
        //     dt: '6 - 8',
        //     my: 'Sep 2023',
        //     category: '2023',
        //     otherdesc:'<h5>September 6 - 8 2023<br>Indian Institute of Technology, Tirupati, India</h5> <h5>Conference Brochure : <a class="c-link" href=\"https://files.iittp.ac.in/pdfs/workshop/2023/29thPFAM 2023 Poster IIT Tirupati.pdf\" target=\"_blank;\"><b>Click here to download</b></a> </h5> <h5>Abstract submission deadline: <b>31 March, 2023</b></h5> <h5>Notification of acceptance of abstract: <b>30 April, 2023</b></h5><h5>Full Papers Submission: <b>30 June, 2023</b></h5><h5>Final Acceptance: <b>15 July, 20233</b></h5><h5>Website Link: <a class="c-link" href="https://pfam29.com/" target="_blank;"><b>Click Here</b></a></h5>'
        // },
        // {
        //     venue: 'IIT Tirupati',
        //     title: 'AMPMT',
        //     description: 'International Webinar on Advances in Materials Processing and Mechanical Testing (AMPMT)',
        //     img: ['https://files.iittp.ac.in/pics/intweb/1.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/2.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/3.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/4.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/5.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/6.jpg',
        //         'https://files.iittp.ac.in/pics/intweb/7.jpg',
        //             ],
        //     dt: '1 - 2',
        //     my: 'Feb 2021',
        //     category: '2021'
        // },
        {
            venue: 'IIT Tirupati',
            title: 'Chemistry and Physics in Highly Polluted Environments',
            description: ' International Conference on Chemistry and Physics in Highly Polluted Environments - jointly organized by IIT Delhi, IIT Tirupati and CIAAS (The China India Association of Atmospheric Scientists).\n' +
                'IIT Tirupati had jointly organized an International conference along with IIT Delhi and CIAAS (The China India Association of Atmospheric Scientists) in Delhi on "Atmospheric Chemistry and Physics in Highly Polluted Environments," 24-26th March 2019. More than 180 people participated, which includes 50-60 from various countries and majority were from China. We received around 220 papers, of which 120 accepted for oral presentation (three parallel sessions), and 50 accepted for poster presentation. The Director, IIT Delhi and The Director, IIT Tirupati were PATRONs of the conference. ',
            img: ['https://files.iittp.ac.in/images/demo/iit/Events/2019/ciaas/1.png',
            'https://files.iittp.ac.in/images/demo/iit/Events/2019/ciaas/2.png'],
            dt: '24 - 26',
            my: 'Mar 2019',
            category: '2019'
        },
        {
            venue: 'IIT Tirupati',
            title: 'THE INDUSTRY 4.0 CONFERENCE',
            description: ' THE INDUSTRY 4.0 CONFERENCE organised by CII, IIT Tirupati, Texas A&M University and APSSDC .\n' ,
            img: ['https://files.iittp.ac.in/Industry4.0/images/demo/gallery/Day1/title.jpg'],
            dt: '17 - 18',
            my: 'Dec 2018',
            category: '2018',
            link: "https://iittp.ac.in/Industry4.0/pages/gallery.html"
        },
        {
            venue: 'IIT Tirupati',
            title: 'Topical Conference of the Indian Society of Atomic and Molecular Physics',
            description: 'The 7th Topical Conference of the Indian Society of Atomic and Molecular Physics was hosted jointly by the IISER-Tirupati and the IIT-Tirupati on 6,7,8 January (2018).',
            img: ['https://files.iittp.ac.in/images/demo/iit/Events/2018/ISAMP/MainGroupPic.jpg'],
            dt: '6 - 8',
            my: 'Jan 2018',
            category: '2018',
            link: "https://iittp.ac.in/ISAMP-Gallery/pages/gallery.html"
        },
        {
            venue: 'IIT Tirupati',
            title: 'International  Conference on Sustainable Energy Technologies for Smart & Clean cities',
            description: 'IIT Tirupati organised an “International Conference on Sustainable Energy Technologies for Smart & Clean cities” (SETS & CC-2016)”, July 27-29, at Amara Raja Batteries Ltd, Tirupati, AP, India.',
            img: ['https://files.iittp.ac.in/images/demo/iit/Events/Amararajabatteries/6.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Amararajabatteries/7.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Amararajabatteries/8.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Amararajabatteries/9.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Amararajabatteries/10.jpg',],
            dt: '27 - 29',
            my: 'Jul 2016',
            category: '2016'
        }
        //TODO: do the data entries for the rest of the conferences
    ];

    const [activeButton, setActiveButton] = useState("View All");
    const [current, setcurrent] = useState(Data);

    const Filter = (category) => {
        setActiveButton(category);
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
            });
            setcurrent(arr);
        }
    };

    function chunkArray(array, chunkSize) {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
    }

    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Function to toggle the description expansion
    const toggleDescriptionExpansion = (index) => {
        setExpandedDescriptions({
            ...expandedDescriptions, [index]: !expandedDescriptions[index],
        });
    };

    return (<div className="distinguished-lectures">
        <Header/>
        <Breadcrumb subtitle={"Conferences"} title={"Home"}/>

        <section className="project-detail">
            <div className="container">
                <div className="section-title center-align mb-50 wow fadeInDown animated"
                     data-animation="fadeInDown" data-delay=".4s">
                    <h5><i className="fal fa-calendar"/> Events</h5>
                    <h2>Conferences</h2>
                </div>
                <Row>
                    <Col md={4} className="c-left">
                        <LeftEvents activeIndex={1}/>
                    </Col>

                    <Col md={8} className="c-left">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div className="my-masonry text-center mb-50 wow fadeInRight animated"
                                     data-animation="fadeInRight" data-delay=".4s">
                                    <div className="button-group filter-button-group ">
                                        <button className={`${activeButton === "View All" ? "active" : ""}`}
                                                data-filter="*" onClick={() => Filter("View All")}> View All
                                        </button>
                                        <button className={`${activeButton === "2023" ? "active" : ""}`}
                                                data-filter=".2023" onClick={() => Filter("2023")}>2023
                                        </button>
                                        <button className={`${activeButton === "2021" ? "active" : ""}`}
                                                data-filter=".2021" onClick={() => Filter("2021")}>2021
                                        </button>
                                        <button className={`${activeButton === "2019" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2019")}>2019
                                        </button>
                                        <button className={`${activeButton === "2018" ? "active" : ""}`}
                                                data-filter=".2018" onClick={() => Filter("2018")}>2018
                                        </button>
                                        <button className={`${activeButton === "2016" ? "active" : ""}`}
                                                data-filter=".2016" onClick={() => Filter("2016")}>2016
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {chunkArray(current, 2).map((row, rowIndex) => (<Row key={rowIndex}>
                            {row.map((event, index) => (
                                <Col key={index} lg={6} md={6} sm={12} className="wow fadeInUp animated"
                                     data-animation="fadeInUp" data-delay=".4s">
                                    <div className="event-item mb-30 hover-zoomin">
                                        <div className="thumb">
                                            <Carousel showArrows={true} showThumbs={false} dynamicHeight={false}
                                                      selectedItem={0}>
                                                {event.img.map((image, imgIndex) => (<div key={imgIndex}>
                                                    <img src={image} alt={`event-img-${imgIndex}`}/>
                                                </div>))}
                                            </Carousel>
                                        </div>
                                        <div className="event-content">
                                            <div className="date">
                                                <strong>{event.dt}</strong> {event.my}
                                            </div>
                                            <h3 style={{minHeight: "87px"}}>
                                                <Link to="/single-event"> {event.title}</Link>
                                            </h3>
                                            <p>
                                                {expandedDescriptions[index] ? event.description : event.description.split(' ').slice(0, 20).join(' ')}
                                                {event.description.split(' ').length > 20 && (
                                                    <span className="read-more">
                                                        <button style={{
                                                            textDecoration: "underline",
                                                            color: "#007bff",
                                                            cursor: 'pointer',
                                                            padding: '0',
                                                            border: 'none',
                                                            background: 'none'
                                                        }}
                                                                onClick={() => toggleDescriptionExpansion(index)}>
                                                            {expandedDescriptions[index] ? " Show Less" : "...Show More"}
                                                        </button>
                                                    </span>)}
                                            </p>
                                            <div className="time">
                                                {event.duration} <i className="fal fa-long-arrow-right"/>{" "}
                                                <strong>{event.venue}</strong>
                                            </div>
                                            <div>
                                                {event.link && event.link !== '' ? (
                                                    <p>To View Gallery: <Link className="c-link" to={event.link} target="_blank"> Click here </Link> </p>
                                                      ) : ("" ) }
                                            </div>
                                    
                                            <div>
                                                {event.otherdesc && event.otherdesc !== '' ? (
                                                    <div dangerouslySetInnerHTML={{ __html: event.otherdesc }} />
                                                ) : (
                                                    ""
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </Col>))}
                        </Row>))}
                    </Col>
                </Row>
            </div>
        </section>
    </div>);
}
